export default "__VITE_ASSET__ace59a16__"